// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueToastr2 from 'vue-toastr-2'
import 'vue-toastr-2/dist/vue-toastr-2.min.css'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {AUTHORIZATION, API_SERVER, BASE_URL} from './constants/constants'
import plugins from './plugins/core-components'
import loading from './plugins/loading'
import Vuelidate from 'vuelidate'
import Highcharts from 'highcharts'
import pieInit from 'highcharts/modules/variable-pie'
window.jQuery = require('jquery')
window.toastr = require('toastr')
require('../static/jquery-qrcode-0.17.0.min')
require('../static/jquery.scannerdetection')

// axios.defaults.baseURL = `https://camera-api.oziquz.ga/web-api/v1/`
axios.defaults.baseURL = API_SERVER + BASE_URL
axios.interceptors.request.use(function (config) {
  if (store.getters.currentToken) {
    config.headers.common[AUTHORIZATION] = store.getters.currentToken
  }
  return config
}, function (error) {
  return Promise.reject(error)
})
axios.interceptors.response.use(function (response) {
  if (response.data && response.data.status === 401) {
    window.toastr.error(response.data.message, { timeOut: 10000 })
    store.dispatch('resetAuth')
    router.push('/login')
  }
  return response
}, function (error) {
  if (!error.response) {
    store.dispatch('resetAuth')
    router.push('/login')
  }
  return Promise.reject(error)
})
pieInit(Highcharts)

Vue.use(BootstrapVue)
Vue.use(VueAxios, axios)
Vue.use(VueToastr2)
Vue.use(plugins)
Vue.use(loading)
Vue.use(Vuelidate)

Vue.component('fa', FontAwesomeIcon)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js